<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'ABSENZEN' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    @if (tabs().length > 0) {
      <work-ui-tabs [(activeTab)]="activeTab"
                     (activeTabChange)="onTabChange($event)"
                     [tabOptions]="tabs()"
                     [saveRouteInUrl]="false"
                     [noPadding]="true">

        <!-- Tab 1: Meine Absenzen -->
        <ng-template workUiTabContent tabReference="MeineAbsenzen">
          @if (activeTab === 'MeineAbsenzen') {
            <!-- Feriensaldo -->
            @if (myBalance()) {
              <sfg-app-absenzen-feriensaldo [balance]="myBalance()!" />
            }

            <!-- Create Button -->
            @if (canCreate()) {
              <div class="flex flex-end margin-bottom-16">
                <work-ui-button
                  (buttonClick)="openCreateModal()"
                  [iconOnly]="true"
                  iconName="add" />
              </div>
            }

            <!-- Loading -->
            @if (myLoading()) {
              <work-ui-loading-spinner [iconSize]="40" [pageLoader]="true" loadingState="loading" />
            }

            <!-- Absences List -->
            @if (!myLoading()) {
              @if (myAbsences().length > 0) {
                @for (absence of myAbsences(); track absence.id) {
                  <sfg-app-absenzen-card
                    [absence]="absence"
                    [canEdit]="!!canUpdate()"
                    [canDelete]="!!canDelete()"
                    (editClick)="openEditModal($event)"
                    (deleteClick)="deleteAbsence($event)" />
                }
              } @else {
                <div class="work-card">
                  <p>{{ 'KEINE_DATEN_VORHANDEN' | translate }}</p>
                </div>
              }
            }
          }
        </ng-template>

        <!-- Tab 2: Alle Mitarbeitenden (Admin) -->
        <ng-template workUiTabContent tabReference="AlleMitarbeitenden">
          @if (activeTab === 'AlleMitarbeitenden') {
            <!-- User Dropdown -->
            @if (userDropdownOptions().length > 0) {
              <div class="margin-bottom-16">
                <work-ui-select
                  (valueChanged)="onAdminUserChange($event)"
                  [options]="userDropdownOptions()"
                  [value]="selectedAdminUserId()"
                  label="MITARBEITER" />
              </div>
            }

            @if (selectedAdminUserId()) {
              <!-- Feriensaldo -->
              @if (adminBalance()) {
                <sfg-app-absenzen-feriensaldo [balance]="adminBalance()!" />
              }

              <!-- Create Button -->
              @if (canCreate()) {
                <div class="flex flex-end margin-bottom-16">
                  <work-ui-button
                    (buttonClick)="openCreateModal()"
                    [iconOnly]="true"
                    iconName="add" />
                </div>
              }

              <!-- Loading -->
              @if (adminLoading()) {
                <work-ui-loading-spinner [iconSize]="40" [pageLoader]="true" loadingState="loading" />
              }

              <!-- Absences List -->
              @if (!adminLoading()) {
                @if (adminAbsences().length > 0) {
                  @for (absence of adminAbsences(); track absence.id) {
                    <sfg-app-absenzen-card
                      [absence]="absence"
                      [canEdit]="!!canUpdate()"
                      [canDelete]="!!canDelete()"
                      [showUserName]="true"
                      (editClick)="openEditModal($event)"
                      (deleteClick)="deleteAbsence($event)" />
                  }
                } @else {
                  <div class="work-card">
                    <p>{{ 'KEINE_DATEN_VORHANDEN' | translate }}</p>
                  </div>
                }
              }
            } @else {
              <div class="work-card">
                <p>{{ 'MITARBEITER_AUSWAEHLEN' | translate }}</p>
              </div>
            }
          }
        </ng-template>

        <!-- Tab 3: Genehmigungen (Admin) -->
        <ng-template workUiTabContent tabReference="Genehmigungen">
          @if (activeTab === 'Genehmigungen') {
            <!-- Loading -->
            @if (pendingLoading()) {
              <work-ui-loading-spinner [iconSize]="40" [pageLoader]="true" loadingState="loading" />
            }

            <!-- Pending Absences -->
            @if (!pendingLoading()) {
              @if (pendingAbsences().length > 0) {
                @for (absence of pendingAbsences(); track absence.id) {
                  <sfg-app-absenzen-card
                    [absence]="absence"
                    [showUserName]="true"
                    [showApprovalActions]="true"
                    (approveClick)="approveAbsence($event)"
                    (rejectClick)="rejectAbsence($event)" />
                }
              } @else {
                <div class="work-card">
                  <p>{{ 'KEINE_DATEN_VORHANDEN' | translate }}</p>
                </div>
              }
            }
          }
        </ng-template>
      </work-ui-tabs>
    }
  </div>

  <!-- Create/Update Modal -->
  <sfg-app-absenzen-create-update-modal #absenceModal
                                         (absenceEdited)="onAbsenceEdited()"
                                         [userId]="getCurrentUserId()" />
</ion-content>
